export default {
  "status.label": "Update",
  "action.checkNow": "Check now",
  "action.checking": "Checking…",
  "action.downloading": "Downloading…",
  "action.installRestart": "Install and restart",
  "action.download": "Download OpenCode",
  "action.installing": "Installing…",
  "toast.latest.title": "You're up to date",
  "toast.latest.description": "You're running the latest version of OpenCode.",
  "migration.title": "Move from Beta to Stable",
  "migration.description":
    "For now, OpenCode Beta is moving to OpenCode Stable. Download version {{version}}, then install OpenCode from the disk image to continue receiving updates.",
  "section.title": "Updates",
  "releaseNotes.title": "Release notes",
  "releaseNotes.description": "Show What's New popups after updates",
  "check.title": "Check for updates",
  "check.description": "Manually check for updates and install if available",
  "menu.check": "Check for Updates…",
  "dialog.checkFailed.message": "Update check failed.",
  "dialog.checkFailed.title": "Update Error",
  "dialog.upToDate.message": "You're up to date.",
  "dialog.upToDate.title": "No Updates",
  "dialog.ready.message": "Update {{version}} downloaded. Restart now?",
  "dialog.ready.title": "Update Ready",
  "dialog.restart": "Restart",
  "dialog.later": "Later",
  "releaseNotes.action.getStarted": "Get started",
  "releaseNotes.action.next": "Next",
  "releaseNotes.action.hideFuture": "Don't show these in the future",
  "releaseNotes.media.alt": "Release preview",
}
